export default __webpack_public_path__ + "static/media/seb.aa97b085.png";